import * as CryptoJS from 'crypto-js';
import { DatePipe } from "@angular/common";
import { GlobalConstant } from "../const/global-constants";
import * as moment from "moment-timezone";

export function encrypt(value: any): string {
  if (value) {
    let key = GlobalConstant.aes_seceret.trim();
    let iv = GlobalConstant.aes_iv.trim();
    let cipher = CryptoJS.AES.encrypt(value, CryptoJS.enc.Utf8.parse(key), {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.CBC
    })
    return cipher.toString();
  }
  else {
    return '';  // Return an empty string instead of null
  }
}

export function decrypt(value: any): string {
  if (value) {
    let key = GlobalConstant.aes_seceret.trim();
    let iv = GlobalConstant.aes_iv.trim();
    try {
      let decrypt = CryptoJS.AES.decrypt(value, CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC
      })
      return decrypt.toString(CryptoJS.enc.Utf8);
    }
    catch (e) {
      return '';
    }
  }
  return '';
}

export function getFormattedDate(date: string | Date, timezone: null | string = null) {
  if (!date) {
    return null;
  }
  if (timezone) {
    return moment.tz(date, timezone).format('MMM DD, YYYY');
  }
  let datePipe = new DatePipe('en-US');
  return datePipe.transform(date, getDateFormat());
}

export function getFormattedDateTime(date: string | Date) {
  let datePipe = new DatePipe('en-US');
  return datePipe.transform(date, getDateTimeFormat())
}

export function getDateFormat() {
  return "dd-MM-YYYY";
}

export function getDateTimeFormat() {
  return getDateFormat();
}

export function getFormattedMonth(date: string | Date, timezone: null | string = null) {
  if (timezone) {
    return moment.tz(date, timezone).format('MMM');
  }
  let datePipe = new DatePipe('en-US');
  return datePipe.transform(date, 'MMM')
}

export function getResourceUrl(path: string) {
  return GlobalConstant.resourseURL + path;
}

export function scrollTop(top: number = 0): void {
  window.scroll({
    top: top,
    left: 0,
    behavior: 'smooth'
  });
}

export function timeSince(date: Date) {
  let seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);
  let interval = seconds / 31536000;

  let val;
  if (interval > 1) {
    val = Math.floor(interval);
    return val + " year" + (val > 1 ? "s" : "");
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    val = Math.floor(interval);
    return val + " month" + (val > 1 ? "s" : "");
  }
  interval = seconds / 86400;
  if (interval > 1) {
    val = Math.floor(interval);
    return val + " day" + (val > 1 ? "s" : "");
  }
  interval = seconds / 3600;
  if (interval > 1) {
    val = Math.floor(interval);
    return val + " hour" + (val > 1 ? "s" : "");
  }
  interval = seconds / 60;
  if (interval > 1) {
    val = Math.floor(interval);
    return val + " minute" + (val > 1 ? "s" : "");
  }

  if (seconds <= 0) {
    return "now";
  }
  return Math.floor(seconds) + " seconds";
}
export function digitValidate(ele: HTMLInputElement): HTMLInputElement {
  ele.value = ele.value.replace(/[^0-9]/g, '');
  return ele;
}

export function getFinancialYear(month: number): string {
  const currentYear = new Date().getFullYear();
  //   const startYear = currentYear;
  const startYear = month >= 4 ? currentYear : currentYear - 1;
  const endYear = startYear + 1;
  return `${startYear}-${endYear}`;
}
export function generateFinancialYears(count: number = 5): string[] {
  const now = new Date();
  const currentMonth = now.getMonth() + 1; // 1-based
  const currentYear = now.getFullYear();

  const startFY = currentMonth >= 4 ? currentYear : currentYear - 1;

  const years = [];
  for (let i = 0; i < count; i++) {
    const start = startFY + i;
    const end = start + 1;
    years.push(`${start}-${end}`);
  }

  return years;
}
export function generatePastFinancialYears1(maxEndYear: number = 2027): string[] {
  const now = new Date();
  const currentMonth = now.getMonth() + 1; // 1-based
  const currentYear = now.getFullYear();

  // If current month is before April, FY started last year
  const currentFYStart = currentMonth >= 4 ? currentYear : currentYear - 1;

  const years = [];
  for (let start = currentFYStart; start < maxEndYear; start++) {
    const end = start + 1;
    years.push(`${start}-${end}`);
  }

  return years;
}
export function generatePastFinancialYears(minStartYear: number = 2024): string[] {
  const now = new Date();
  const currentMonth = now.getMonth() + 1;
  const currentYear = now.getFullYear();
  const currentFYStart = currentMonth >= 4 ? currentYear : currentYear - 1;

  const years = [];
  for (let start = minStartYear; start <= currentFYStart; start++) {
    years.push(`${start}-${start + 1}`);
  }

  return years;
}
export function getMonthsForFinancialYear(selectedFY: string): { value: string; label: string }[] {
  const allFYMonths = [
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
  ];

  const now = new Date();
  const currentMonth = now.getMonth();
  const currentFYStart = now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1; // FY starts in April

  const [selectedStartYear] = selectedFY.split('-').map(Number);

  if (selectedStartYear > currentFYStart) {
    return allFYMonths; // future FY – show all
  } else if (selectedStartYear === currentFYStart) {
    // Filter out months before current
    return allFYMonths.filter(month => {
      const monthNum = parseInt(month.value, 10);
      if (monthNum >= 4) {
        return currentMonth <= monthNum;
      } else {
        // Jan–Mar are part of next calendar year
        return currentMonth <= monthNum || currentMonth >= 4;
      }
    });
  }

  return []; // Past FYs not allowed (optional)
}
export function getFileName(url: string): string {
  return url.split('/').pop() || 'File';
}
// export function getFileIcon(file: File): string {
//   if (file.type.includes('pdf')) {
//     return 'https://img.icons8.com/color/48/000000/pdf.png';
//   } else if (file.type.includes('word') || file.name.endsWith('.doc') || file.name.endsWith('.docx')) {
//     return 'https://img.icons8.com/color/48/000000/ms-word.png';
//   } else if (file.type.includes('excel') || file.name.endsWith('.xls') || file.name.endsWith('.xlsx')) {
//     return 'https://img.icons8.com/color/48/000000/ms-excel.png';
//   } else {
//     return 'https://img.icons8.com/color/48/000000/file.png';
//   }
// }
export function getFileIcon(file: File | string): string {
  const defaultIcon = "https://img.icons8.com/color/48/000000/file.png"; // Generic file icon
  const icons: { [key: string]: string } = {
    pdf: "https://img.icons8.com/color/48/000000/pdf.png",
    doc: "https://img.icons8.com/color/48/000000/ms-word.png",
    docx: "https://img.icons8.com/color/48/000000/ms-word.png",
    xls: "https://img.icons8.com/color/48/000000/ms-excel.png",
    xlsx: "https://img.icons8.com/color/48/000000/ms-excel.png"
  };

  let fileName = typeof file === "string" ? file : file.name;
  let fileExt = fileName.split(".").pop()?.toLowerCase() || "";

  return icons[fileExt] || defaultIcon;
}
